import { Link } from "react-router-dom";

export default function OrderCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="card-surface p-10 max-w-lg w-full text-center" data-testid="order-cancel-page">
        <h1 className="font-display text-3xl mb-3">No worries.</h1>
        <p className="text-neutral-400 text-sm">Checkout was cancelled and you weren't charged. Come back whenever you're ready.</p>
        <Link to="/" className="inline-block mt-8 text-sm text-teal-300 hover:text-teal-200" data-testid="order-cancel-home">Back to Why We Recover</Link>
      </div>
    </div>
  );
}
